export const NavigationState = {
    END: '終',
    START: '起'
}
